import { Component, ViewChild, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { RfpClarificationQueriesComponent } from '@/app/components/projects/project-development/tendering/inivitation-to-tender/itt-sender-side/Clarification/rfp-clarification-queries/rfp-clarification-queries.component';
import { RfpClarificationAddendumsComponent } from '@/app/components/projects/project-development/tendering/inivitation-to-tender/itt-sender-side/Clarification/rfp-clarification-addendums/rfp-clarification-addendums.component';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-rfp-clarification-wrapper',
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
    RfpClarificationQueriesComponent,
    RfpClarificationAddendumsComponent,
  ],
  templateUrl: './rfp-clarification-wrapper.component.html',
  styleUrl: './rfp-clarification-wrapper.component.css',
})
export class RfpClarificationWrapperComponent implements OnInit {
  @ViewChild(RfpClarificationQueriesComponent)
  rfpClarificationQueriesComponent!: RfpClarificationQueriesComponent;

  selectedQueriesIds: number[] = [];
  selectedSection: string = '';

  constructor(private route: ActivatedRoute) {}

  ngOnInit() {
    this.route.queryParamMap.subscribe((params) => {
      this.selectedSection = params.get('tab') ?? 'clarification';
    });
  }

  sendDialogueEventToQueriesChild(value) {
    switch (value) {
      case 'answer_selected_queries':
        this.rfpClarificationQueriesComponent.openRFPClarificationAnswerDialog(event);
        break;

      case 'create_addendum':
        this.rfpClarificationQueriesComponent.showAddendumModal();
        break;

      default:
        break;
    }
  }
}
